export const SIGN_IN_USER = "SIGN_IN_USER";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
